import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "sonner";

export const useClipboard = (resetDelay = 2000) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = (successMessage = "Copied to clipboard") => {
    setIsCopied(true);
    toast.success(successMessage);
    setTimeout(() => setIsCopied(false), resetDelay);
  };

  return { CopyToClipboard, isCopied, handleCopy };
};
